// extracted by mini-css-extract-plugin
module.exports = {"row":"CreateNotifications_row__3wXfu","col":"CreateNotifications_col__YykVc","card":"CreateNotifications_card__3cNY8"};